/* istanbul ignore file */

import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const ContactEntityHeader = () => {
  return <EntityHeader entityTitleSource="fullName" defaultAuthor={DEFAULT_ENTITY_AUTHOR} />;
};

export default ContactEntityHeader;
